import { render } from "./RequestMandate.vue?vue&type=template&id=e7c9153c"
import script from "./RequestMandate.vue?vue&type=script&lang=js"
export * from "./RequestMandate.vue?vue&type=script&lang=js"
script.render = render

export default script